import { render } from "./FormCavityWallPaintView.vue?vue&type=template&id=3270cce3"
import script from "./FormCavityWallPaintView.vue?vue&type=script&lang=js"
export * from "./FormCavityWallPaintView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__